import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, Subject, Subscription } from 'rxjs';
import { DatasetService } from './dataset.service';

@Injectable()
export class CheckoutService{

	public loading: BehaviorSubject<boolean>;

	constructor(private datasetService: DatasetService){
		this.loading = new BehaviorSubject<boolean>(false);
	}

	checkout(url: string, formData?: any): Observable<any>{
		const result = new Subject<any>();
		this.loading.next(true);
		this.datasetService.post(url, formData)
		.subscribe({
			next: (response) => {
				result.next(response);
				result.complete();
				this.loading.next(false);
			},
			error: (response) => {
				result.error(response);
				result.complete();
				this.loading.next(false);
			}
		});
		return result;
	}

	confirmBooking(formData: any): Observable<any>{
		const result = new Subject<any>();
		this.loading.next(true);
		this.datasetService.post('/checkout/stripe-confirm-booking', formData)
		.subscribe({
			next: (response) => {
				result.next(response);
				result.complete();
				this.loading.next(false);
			},
			error: (response) => {
				result.next();
				result.complete();
				this.loading.next(false);
				console.log(response);
			}
		});
		return result;
	}

	loadCountries(): Observable<any>{
		const result = new Subject<any>();
		this.datasetService.get('/dataset/nations', {perPage: 500})
		.subscribe({
			next: (response) => {
				result.next(response);
				result.complete();
			},
			error: (response) => {
				console.log(response);
			}
		});
		return result;
	}
}
